<template>
    <div>
        <user-layout class="pb-12 md:pb-20">

            <Dialog :visible.sync="showModal" :closable="true" :dismissableMask="true" modal class="w-2/3">
              <profile :member-id="this.memberId"/>
            </Dialog>

            <div class="flex flex-wrap items-center justify-between mb-3">
                <h1 class="flex flex-wrap items-center text-2xl font-bold leading-tight text-black md:text-4xl">
                    <router-link to="/projects" class="text-gray-600">Minu projektid</router-link>
                    <span class="px-4 py-2 text-xs font-bold text-blue-500 pi pi-chevron-right"></span>
                    <span>{{ project && project.name || '' }}</span>
                </h1>

                <div
                    v-if="project && project.status !== null
                    && ProjectStatus.STOPPED === project.status.id
                    && ProjectUserStatus.STOPPED === projectUser.status.id"
                    class="my-2 px-3 py-1 text-xs font-semibold rounded text-white uppercase bg-red-500"
                >Peatatud
                </div>

                <div
                    v-if="project && ProjectUserStatus.DECLINED === projectUser.status.id"
                    class="my-2 px-3 py-1 text-xs font-semibold rounded text-white uppercase bg-red-500"
                >Keeldutud
                </div>

                <div
                    v-else-if="project && project.status !== null
                    && ProjectStatus.isWaiting(project.status.id)
                    && ProjectUserStatus.isWaiting(projectUser.status.id)"
                    class="my-2 px-3 py-1 text-xs font-semibold rounded text-white uppercase bg-yellow-500"
                >Ootel
                </div>

                <div
                    v-else-if="project && project.status !== null
                    && ProjectStatus.COMPLETED === project.status.is
                    && ProjectUserStatus.isCompleted(projectUser.status.id)"
                    class="my-2 px-3 py-1 text-xs font-semibold rounded text-white uppercase bg-green-500"
                >Lõpetatud
                </div>

                <div
                    v-else-if="project && projectUser.status.id === ProjectUserStatus.UNRESPONSIVE"
                    class="my-2 px-3 py-1 text-xs font-semibold rounded text-white uppercase bg-blue-500"
                >Vastuseta
                </div>
                <div
                    v-else-if="project && projectUser.status.id === ProjectUserStatus.NOT_CHOSEN"
                    class="my-2 px-3 py-1 text-xs font-semibold rounded text-white uppercase bg-red-500"
                >Mitte valitud
                </div>
            </div>

            <h3 class="text-lg font-semibold">Projekt number
                <span class="text-blue-500">{{ project && project.number || 0}}</span>
            </h3>

            <div class="flex flex-wrap items-start justify-between -mx-4 mt-8">
                <div class="w-full md:w-1/2 lg:w-3/5 px-4 flex flex-wrap justify-between -mx-4">
                    <div class="flex-auto p-4">
                        <h4 class="mb-1 text-sm text-blue-500 uppercase">Hoone liik</h4>
                        <p class="text-lg">{{ project && project.building_type && project.building_type.name }}</p>
                    </div>

                    <div class="flex-auto p-4">
                        <h4 class="mb-1 text-sm text-blue-500 uppercase">Suletud netopind</h4>
                        <p class="text-lg">{{ project && project.size }} m<sup>2</sup></p>
                    </div>

                    <div class="flex-auto p-4">
                        <h4 class="mb-1 text-sm text-blue-500 uppercase">Projekti osad ja etapid</h4>
                        <p class="text-lg">{{ project && project.project_area }}</p>
                        <p class="text-lg">{{ project && project.phases_str }}</p>
                    </div>

                    <div v-if="project.condition" class="flex-auto p-4">
                        <h4 class="mb-1 text-sm text-blue-500 uppercase">Seisukord</h4>
                        <p class="text-lg">{{ project && project.condition }}</p>
                    </div>

                    <div v-if="project && project.permission !== null" class="flex-auto p-4">
                        <h4 class="mb-1 text-sm text-blue-500 uppercase">Ehitusluba</h4>
                        <p class="text-lg">{{ project && project.permission ? 'Olemas' : 'Vaja taotleda' }}</p>
                    </div>

                    <div v-if="project && project.energyclass" class="flex-auto p-4">
                        <h4 class="mb-1 text-sm text-blue-500 uppercase">Energiaklass</h4>
                        <p class="text-lg">{{ project.energyclass }}</p>
                    </div>

                    <div v-if="project && project.address" class="flex-auto p-4">
                        <h4 class="mb-1 text-sm text-blue-500 uppercase">Objekti aadress</h4>
                        <p class="text-lg">{{ project.address }}</p>
                    </div>

                    <div v-if="project && project.created_at" class="flex-auto p-4">
                      <h4 class="mb-1 text-sm text-blue-500 uppercase">Projekt loodud</h4>
                      <p class="text-lg">{{ project.created_at }}</p>
                    </div>

                    <div v-if="project && (project.area_estimated_price || project.area_tasks_price)" class="flex-auto p-4">
                        <h4 class="mb-1 text-sm text-blue-500 uppercase">Pakutud hind / Täpsustatud hind - {{ project.area_name }}</h4>
                        <p v-if="project.area_estimated_price && project.area_tasks_price" class="text-lg">{{ project.area_estimated_price }} € / {{ project.area_tasks_price }} €</p>
                        <p v-else-if="project.area_estimated_price && !project.area_tasks_price" class="text-lg">{{ project.area_estimated_price }} € / - €</p>
                        <p v-else-if="!project.area_estimated_price && project.area_tasks_price" class="text-lg">- € / {{ project.area_tasks_price }} €</p>
                      <p v-else class="text-lg">- €</p>

                    </div>

                    <div v-if="project && project.above_ground_floors" class="flex-auto p-4">
                        <h4 class="mb-1 text-sm text-blue-500 uppercase">Maa-pealseid korruseid</h4>
                        <p class="text-lg">{{ project.above_ground_floors }}</p>
                    </div>

                    <div v-if="project && project.underground_floors" class="flex-auto p-4">
                        <h4 class="mb-1 text-sm text-blue-500 uppercase">Maa-aluseid korruseid</h4>
                        <p class="text-lg">{{ project.underground_floors }}</p>
                    </div>

                    <div v-if="project.status !== null && (project.status.id === 1  || project.status.id === 2) && hasContract" class="flex-auto p-4">
                        <h4 class="mb-1 text-sm text-blue-500 uppercase">Leping</h4>
                        <a @click="downloadContract()" class="text-lg hover:text-blue-500 flex items-center">
                            <div
                                class="pi pi-download w-6 h-6 bg-blue-100 rounded-full mr-3 flex items-center justify-center text-xs text-blue-500 font-semibold">
                            </div>
                            Leping_{{ project.number }}.pdf
                        </a>
                    </div>

                    <div v-if="project && project.comment" class="flex-auto p-4">
                      <h4 class="mb-1 text-sm text-blue-500 uppercase">Kommentaar</h4>
                      <p class="text-lg">{{ project.comment }}</p>
                    </div>

                    <div v-if="project && project.client" class="flex-auto p-4">
                      <h4 class="mb-1 text-sm text-blue-500 uppercase">Tellija</h4>
                      <div
                          class="flex items-center cursor-pointer"
                          @click="showProfile(project.client.id)">
                        <div class="flex items-center justify-center w-12 h-12 bg-blue-500 rounded-full">
                          <div class="text-white text-xl font-semibold">
                            {{ project.client && project.client.name && project.client.name.split(' ').map((n) => n[0]).join('') }}
                          </div>
                        </div>
                        <p class="text-lg pl-2">
                          {{ project.client.name }}
                        </p>
                      </div>
                    </div>

                    <div v-if="project && project.teamLead" class="flex-auto p-4">
                      <h4 class="mb-1 text-sm text-blue-500 uppercase">Projektijuht</h4>
                      <div
                          class="flex items-center cursor-pointer"
                          @click="showProfile(project.teamLead.id)">
                        <div class="flex items-center justify-center w-12 h-12 bg-blue-500 rounded-full">
                          <div class="text-white text-xl font-semibold">
                            {{ project.teamLead && project.teamLead.name && project.teamLead.name.split(' ').map((n) => n[0]).join('') }}
                          </div>
                        </div>
                        <p class="text-lg pl-2">
                          {{ project.teamLead.name }}
                        </p>
                      </div>
                    </div>
                </div>

                <div class="w-full md:w-1/2 lg:w-1/3 p-4">
                    <template v-if="project && project.status !== null">
                      <div v-if="!ProjectUserStatus.isNotMember(projectUser.status.id)">
                        <h4  class="mb-1 text-sm text-blue-500 uppercase">Rahaline ülevaade</h4>
                      </div>

                      <div class="flex flex-wrap justify-between items-center py-2 border-gray-200">
                        <div class="mb-2 text-4xl font-semibold md:text-5xl">{{ project.totalActualPrice }} €</div>
                        <div>Kogu projekti maksumus</div>
                      </div>

                      <div class="flex flex-wrap justify-between py-2 border-gray-200">
                        <div class="font-semibold">{{ project.actualServiceFee }} €</div>
                        <div>Hinnas sisalduv teenustasu (tasub tellija)</div>
                      </div>

                      <div v-if="ProjectUserRole.isSpecialist(projectUser.role.id)"
                           class="flex flex-wrap justify-between py-2 border-gray-200">
                        <div class="font-semibold">{{ project.personalPrice }} €</div>
                        <div>Minu projekti osa maksumus</div>
                      </div>

                      <div v-if="project.status.id === ProjectStatus.ACTIVE && project.deposit && project.undeposited"
                           class="flex flex-wrap justify-between py-2 border-gray-200">
                        <div class="font-semibold">{{ project.deposit | splitNumber  }} € / {{ project.undeposited | splitNumber  }}  €</div>
                        <div>Deponeeritud/deponeerimata</div>
                      </div>
                    </template>

                    <router-link
                        v-if="false && project.status !== null && project.status.id === 1"
                        :to="`/project/${project.id}/deposit/`" class="mt-4 w-full uppercase text-white bg-orange-400 btn"
                    >Deponeeri raha
                    </router-link>

                    <button
                        v-if="project.status !== null && ProjectStatus.ACTIVE_CONCLUDE_CONTRACT === project.status.id
                        && !project.isContractAccepted && projectUser.status.id === ProjectUserStatus.TASKS_PICKED"
                         class="mt-4 w-full uppercase text-white bg-orange-400 btn"
                         :class="!privacyCheckbox ? 'p-disabled' : ''"
                        @click="contractAcceptance"
                        ref="contractAcceptanceButton"
                    >Kinnita leping
                    </button>

                    <template v-if="ProjectUserRole.isClient(projectUser.role.id)">
                        <router-link
                            v-if="ProjectStatus.isTeamLeadNotChosenStatuses(project.status.id)"
                            :to="`/project/${projectUser.id}/pick-manager/`"
                            class="mt-4 w-full uppercase text-white bg-orange-400 btn"
                        >Vali projektijuht
                        </router-link>
                    </template>

                    <template v-if="projectUser.status.id === ProjectUserStatus.INVITED && !ProjectUserRole.isClient(projectUser.role.id)">
                        <router-link
                            v-if="ProjectStatus.isTeamLeadNotChosenStatuses(project.status.id) || project.status.id === 8"
                            :to="`/project/${projectUser.id}/accept/`"
                            class="mt-4 w-full uppercase text-white bg-orange-400 btn"
                        >Olen huvitatud
                        </router-link>
                        <router-link
                            v-if="ProjectStatus.isTeamLeadNotChosenStatuses(project.status.id) || project.status.id === 8"
                            :to="`/project/${projectUser.id}/decline/`"
                            class="mt-4 w-full uppercase text-black bg-white-400 btn"
                        >Loobun
                        </router-link>
                    </template>

                    <template v-if="ProjectUserRole.isTeamLead(projectUser.role.id)">
                        <router-link
                            v-if="project.status.id === 8"
                            :to="`/project/${projectUser.id}/create-team/`"
                            class="mt-4 w-full uppercase text-white bg-orange-400 btn"
                        >Koosta meeskond
                        </router-link>
                    </template>

                    <template v-if="ProjectUserRole.isTeamLead(projectUser.role.id)">
                      <router-link
                          v-if="project.status.id === 2 || ProjectStatus.isTeamLeadNotChosenStatuses(project.status.id) || project.status.id === 8"
                          :to="`/project/${projectUser.id}/stop`"
                          class="mt-4 w-full uppercase text-white bg-orange-400 btn"
                      >Katkesta projekt
                      </router-link>
                    </template>

                    <div
                        v-if="project.status !== null && project.status.id === 2 && !project.isContractAccepted && hasContract"
                        class="p-field-checkbox mt-4"
                    >
                        <checkbox
                            id="privacy"
                            input-id="privacy"
                            name="privacy"
                            binary
                            v-model="privacyCheckbox"
                        />
                        <span class="ml-3 text-sm">Nõustun lepingu sõlmimise tingimustega</span>
                    </div>
                </div>

                <div v-if="ProjectUserRole.isTeamLead(projectUser.role.id) && projectWarnings.length > 0" class="w-full md:w-1/2 lg:w-3/5 p-4">
                  <accordion class="warning-accordion">
                    <accordion-tab class="rounded-lg shadow-xl">
                      <template #header>
                        <span class="text-red-500">Hoiatused</span>
                      </template>
                      <div v-for="warning in projectWarnings"
                           :key="warning.message"
                           class="py-4 px-4 my-3 rounded-lg shadow-xl">

                        <div class="flex items-center">
                          <i v-if="warning.type.id === ProjectWarning.INFO" class="pi pi-info-circle text-blue-500"/>
                          <i v-else-if="warning.type.id === ProjectWarning.WARN" class="pi pi-exclamation-triangle text-yellow-500"/>
                          <i v-else-if="warning.type.id === ProjectWarning.ERROR" class="pi pi-exclamation-circle text-red-500"/>
                          <span class="pl-2">{{ warning.message }}</span>
                        </div>
                      </div>
                    </accordion-tab>
                  </accordion>
                </div>
            </div>

            <div v-if="(projectOverview.fundingTable && projectOverview.fundingTable.fundingTableSection.length > 0) || (projectOverview.tasksTable && projectOverview.tasksTable.length > 0)" class="my-8 md:my-12">
                <h1 class="mb-6 text-2xl font-bold leading-tight text-black md:text-4xl">
                  Projekti ülevaade
                  <span
                      v-tooltip.top="
                        '<div>' +
                        'Ülevaates on kuvatud kogu meeskonna statistika etappide ja valdkondade kaupa. ' +
                        'Klikates “>” avaneb statistika projekteerijate kaupa.' +
                        '</div>'"
                      class="pi pi-info-circle text-gray-600"
                      escape="false"
                  ></span>
                </h1>

                <tab-view>
                    <tab-panel v-if="projectOverview.fundingTable && projectOverview.fundingTable.fundingTableSection.length > 0">
                        <template slot="header">
                            <h3 class="text-lg">Rahastus</h3>
                        </template>

                        <div class="py-6">
                            <data-table
                                :value="projectOverview.fundingTable.fundingTableSection"
                                :expanded-rows.sync="fundingTableExpandedRows"
                                data-key="id"
                                class="p-datatable-responsive">

                                <column expander header-class="w-8"></column>

                                <column field="area" header="Valdkond" header-style="width: 25%;" footer="Kokku">
                                    <template #body="slotProps">
                                        <span class="p-column-title">Valdkond</span>
                                        <span class="font-semibold">{{ slotProps.data.area }}</span>
                                    </template>
                                </column>

                                <column field="sketch" header="Eskiis" :footer="projectOverview.fundingTable.sketch_total">
                                    <template #body="slotProps">
                                        <span class="p-column-title">Eskiis</span>
                                        {{ slotProps.data.sketch }}
                                    </template>
                                </column>

                                <column field="pre" header="Eelprojekt" :footer="projectOverview.fundingTable.pre_total">
                                    <template #body="slotProps">
                                        <span class="p-column-title">Eelprojekt</span>
                                        {{ slotProps.data.pre }}
                                    </template>
                                </column>

                                <column field="mainproject" header="Põhiprojekt" :footer="projectOverview.fundingTable.mainproject_total">
                                    <template #body="slotProps">
                                        <span class="p-column-title">Põhiprojekt</span>
                                        {{ slotProps.data.mainproject }}
                                    </template>
                                </column>

                                <column field="workproject" header="Tööprojekt" :footer="projectOverview.fundingTable.workproject_total">
                                    <template #body="slotProps">
                                        <span class="p-column-title">Tööprojekt</span>
                                        {{ slotProps.data.workproject }}
                                    </template>
                                </column>

                                <column field="research" header="Uuringud" :footer="projectOverview.fundingTable.research_total">
                                  <template #body="slotProps">
                                    <span class="p-column-title">Uuringud</span>
                                    {{ slotProps.data.research }}
                                  </template>
                                </column>

                                <column field="all" header="Kokku"
                                        header-class="text-right"
                                        body-class="text-right"
                                        :footer="projectOverview.fundingTable.all_total"
                                        footer-class="text-right pr-0">
                                    <template #body="slotProps">
                                        <span class="p-column-title">Kokku</span>
                                        {{ slotProps.data.all }}
                                    </template>
                                </column>

                                <template #expansion="slotProps">
                                    <data-table
                                        :value="slotProps.data.items"
                                        class="p-datatable-responsive p-datatable-nolines p-datatable-noheader"
                                    >
                                        <column field="id" body-class="w-8">
                                            <template #body="slotProps"></template>
                                        </column>

                                        <column field="name" body-style="width: 25%;">
                                            <template #body="slotProps">
                                                <span class="p-column-title">Nimi</span>
                                                {{ slotProps.data.name }}
                                            </template>
                                        </column>

                                        <column field="sketch">
                                            <template #body="slotProps">
                                                <span class="p-column-title">Eskiis</span>
                                                {{ slotProps.data.sketch }}
                                            </template>
                                        </column>

                                        <column field="pre">
                                            <template #body="slotProps">
                                                <span class="p-column-title">Eelprojekt</span>
                                                {{ slotProps.data.pre }}
                                            </template>
                                        </column>

                                        <column field="mainproject">
                                            <template #body="slotProps">
                                                <span class="p-column-title">Põhiprojekt</span>
                                                {{ slotProps.data.mainproject }}
                                            </template>
                                        </column>

                                        <column field="workproject">
                                            <template #body="slotProps">
                                                <span class="p-column-title">Tööprojekt</span>
                                                {{ slotProps.data.workproject }}
                                            </template>
                                        </column>

                                        <column field="research">
                                            <template #body="slotProps">
                                                <span class="p-column-title">Uuringud</span>
                                                {{ slotProps.data.research }}
                                            </template>
                                        </column>

                                        <column field="all" body-class="text-right">
                                            <template #body="slotProps">
                                                <span class="p-column-title">Kokku</span>
                                                {{ slotProps.data.all }}
                                            </template>
                                        </column>
                                    </data-table>
                                </template>
                            </data-table>
                        </div>
                    </tab-panel>

                    <tab-panel v-if="projectOverview.tasksTable && projectOverview.tasksTable.length > 0">
                        <template slot="header">
                            <h3 class="text-lg">Ülesanded</h3>
                        </template>

                        <div class="py-6">
                            <data-table
                                :value="projectOverview.tasksTable"
                                :expanded-rows.sync="overviewTableExpandedRows"
                                :row-class="showExpander"
                                data-key="id"
                                class="p-datatable-responsive"
                            >
                                <!-- TODO: Don't show expander if no items-->
                                <column expander header-class="w-8"></column>

                                <column field="area" header="Valdkond" header-style="width: 25%;">
                                    <template #body="slotProps">
                                        <span class="p-column-title">Valdkond</span>
                                        <span class="font-semibold">{{ slotProps.data.area }}</span>
                                    </template>
                                </column>

                                <column field="sketch" header="Eskiis">
                                    <template #body="slotProps">
                                        <span class="p-column-title">Eskiis</span>
                                        {{ slotProps.data.sketch }}
                                    </template>
                                </column>

                                <column field="pre" header="Eelprojekt">
                                    <template #body="slotProps">
                                        <span class="p-column-title">Eelprojekt</span>
                                        {{ slotProps.data.pre }}
                                    </template>
                                </column>

                                <column field="mainproject" header="Põhiprojekt">
                                    <template #body="slotProps">
                                        <span class="p-column-title">Põhiprojekt</span>
                                        {{ slotProps.data.mainproject }}
                                    </template>
                                </column>

                                <column field="workproject" header="Tööprojekt">
                                    <template #body="slotProps">
                                        <span class="p-column-title">Tööprojekt</span>
                                        {{ slotProps.data.workproject }}
                                    </template>
                                </column>

                                <column field="research" header="Uuringud">
                                    <template #body="slotProps">
                                        <span class="p-column-title">Uuringud</span>
                                        {{ slotProps.data.research }}
                                    </template>
                                </column>

                                <column field="all" header="Kokku" header-class="text-right" body-class="text-right">
                                    <template #body="slotProps">
                                        <span class="p-column-title">Kokku</span>
                                        {{ slotProps.data.all }}
                                    </template>
                                </column>

                                <template #expansion="slotProps">
                                    <data-table
                                        :value="slotProps.data.items"
                                        class="p-datatable-responsive p-datatable-nolines p-datatable-noheader"
                                    >
                                        <column field="id" body-class="w-8">
                                            <template #body="slotProps"></template>
                                        </column>

                                        <column field="name" body-style="width: 25%;">
                                            <template #body="slotProps">
                                                <span class="p-column-title">Nimi</span>
                                                {{ slotProps.data.name }}
                                            </template>
                                        </column>

                                        <column field="sketch">
                                            <template #body="slotProps">
                                                <span class="p-column-title">Eskiis</span>
                                                {{ slotProps.data.sketch }}
                                            </template>
                                        </column>

                                        <column field="pre">
                                            <template #body="slotProps">
                                                <span class="p-column-title">Eelprojekt</span>
                                                {{ slotProps.data.pre }}
                                            </template>
                                        </column>

                                        <column field="mainproject">
                                            <template #body="slotProps">
                                                <span class="p-column-title">Põhiprojekt</span>
                                                {{ slotProps.data.mainproject }}
                                            </template>
                                        </column>

                                        <column field="workproject">
                                            <template #body="slotProps">
                                                <span class="p-column-title">Tööprojekt</span>
                                                {{ slotProps.data.workproject }}
                                            </template>
                                        </column>

                                        <column field="research">
                                            <template #body="slotProps">
                                                <span class="p-column-title">Uuringud</span>
                                                {{ slotProps.data.research }}
                                            </template>
                                        </column>

                                        <column field="all" body-class="text-right">
                                            <template #body="slotProps">
                                                <span class="p-column-title">Kokku</span>
                                                {{ slotProps.data.all }}
                                            </template>
                                        </column>
                                    </data-table>
                                </template>
                            </data-table>
                        </div>
                    </tab-panel>

                    <tab-panel v-if="ProjectUserRole.isDecisionMaker(projectUser.role.id) && projectOverview.areaPhaseTable && projectOverview.areaPhaseTable.length > 0">
                    <template slot="header">
                      <h3 class="text-lg">Valdkonnad ja etapid</h3>
                    </template>

                    <div class="py-6">
                      <data-table
                          :value="projectOverview.areaPhaseTable"
                          data-key="id"
                          class="p-datatable-responsive"
                          :row-class="areaRowClass"
                      >

                        <column field="area" header="Valdkond" header-style="width: 25%;" header-class="px-3" body-class="px-3">
                          <template #body="slotProps">
                            <div :class="slotProps.data.enabled ? null : 'p-disabled'">
                              <span class="p-column-title">Valdkond</span>
                              <span class="font-semibold">{{ slotProps.data.area }}</span>
                                <i v-if="slotProps.data.enabled
                                         && (slotProps.data.sketch === null || !slotProps.data.sketch)
                                         && (slotProps.data.pre === null || !slotProps.data.pre)
                                         && (slotProps.data.mainproject === null || !slotProps.data.mainproject)
                                         && (slotProps.data.workproject === null || !slotProps.data.workproject)
                                         && (slotProps.data.research === null || !slotProps.data.research)"
                                   v-tooltip.top="
                                    '<div>' +
                                    'Valdkonna etapid valimata' +
                                    '</div>'"
                                   class="pl-2 text-red-500 pi pi-exclamation-circle"
                                   escape="false"/>
                            </div>
                          </template>
                        </column>

                        <column field="sketch" header="Eskiis" header-class="px-3" body-class="px-3">
                          <template #body="slotProps">
                            <div v-if="slotProps.data.sketch !== null" :class="slotProps.data.enabled ? null : 'p-disabled'">
                              <span class="p-column-title">Eskiis</span>
                              <i @click="isTeamLeadInWaitingProjectStatus() && toggleProjectAreaPhase(slotProps.data.id, Phase.SKETCH)"
                                 :class="[slotProps.data.sketch ? 'pi-minus text-red-500' : 'pi-plus text-green-500',
                                     isTeamLeadInWaitingProjectStatus() ? 'cursor-pointer' : null]"
                                 class="text-xl pi"/>
                            </div>
                          </template>
                        </column>

                        <column field="pre" header="Eelprojekt" header-class="px-3" body-class="px-3">
                          <template #body="slotProps">
                            <span class="p-column-title">Eelprojekt</span>
                            <div v-if="slotProps.data.pre !== null" :class="slotProps.data.enabled ? null : 'p-disabled'">
                              <i @click="isTeamLeadInWaitingProjectStatus() && toggleProjectAreaPhase(slotProps.data.id, Phase.PRE)"
                                 :class="[slotProps.data.pre ? 'pi-minus text-red-500' : 'pi-plus text-green-500',
                                    isTeamLeadInWaitingProjectStatus() ? 'cursor-pointer' : null]"
                                 class="text-xl pi"/>
                            </div>
                          </template>
                        </column>

                        <column field="mainproject" header="Põhiprojekt" header-class="px-3" body-class="px-3">
                          <template #body="slotProps">
                            <div v-if="slotProps.data.mainproject !== null" :class="slotProps.data.enabled ? null : 'p-disabled'">
                              <span class="p-column-title">Põhiprojekt</span>
                              <i @click="isTeamLeadInWaitingProjectStatus() && toggleProjectAreaPhase(slotProps.data.id, Phase.MAIN)"
                                 :class="[slotProps.data.mainproject ? 'pi-minus text-red-500' : 'pi-plus text-green-500',
                                    isTeamLeadInWaitingProjectStatus() ? 'cursor-pointer' : null]"
                                 class="text-xl pi"/>
                            </div>
                          </template>
                        </column>

                        <column field="workproject" header="Tööprojekt" header-class="px-3" body-class="px-3">
                          <template #body="slotProps">
                            <div v-if="slotProps.data.workproject !== null" :class="slotProps.data.enabled ? null : 'p-disabled'">
                              <span class="p-column-title">Tööprojekt</span>
                              <i @click="isTeamLeadInWaitingProjectStatus() && toggleProjectAreaPhase(slotProps.data.id, Phase.WORK)"
                                 :class="[slotProps.data.workproject ? 'pi-minus text-red-500' : 'pi-plus text-green-500',
                                    isTeamLeadInWaitingProjectStatus() ? 'cursor-pointer' : null]"
                                 class="text-xl pi"/>
                            </div>
                          </template>
                        </column>

                        <column field="research" header="Uuringud" header-class="px-3" body-class="px-3">
                          <template #body="slotProps">
                            <div v-if="slotProps.data.research !== null" :class="slotProps.data.enabled ? null : 'p-disabled'">
                              <span class="p-column-title">Uuringud</span>
                              <i @click="isTeamLeadInWaitingProjectStatus() && toggleProjectAreaPhase(slotProps.data.id, Phase.RESEARCH)"
                                 :class="[slotProps.data.research ? 'pi-minus text-red-500' : 'pi-plus text-green-500',
                                    isTeamLeadInWaitingProjectStatus() ? 'cursor-pointer' : null]"
                                 class="text-xl pi"/>
                            </div>
                          </template>
                        </column>

                        <column field="all" header-class="text-right" body-class="text-right px-3">
                          <template #body="slotProps">
                            <i @click="isTeamLeadInWaitingProjectStatus() && toggleProjectArea(slotProps.data.id)"
                               :class="[slotProps.data.enabled ? 'pi-minus text-red-500' : 'pi-plus text-green-500',
                                  isTeamLeadInWaitingProjectStatus() ? 'cursor-pointer' : null]"
                               class="text-xl pi"/>
                          </template>
                        </column>

                        <template #expansion="slotProps">
                          <data-table
                              :value="slotProps.data.items"
                              class="p-datatable-responsive p-datatable-nolines p-datatable-noheader"
                          >
                            <column field="id" body-class="w-8">
                              <template #body="slotProps"></template>
                            </column>

                            <column field="name" body-style="width: 25%;">
                              <template #body="slotProps">
                                <span class="p-column-title">Nimi</span>
                                {{ slotProps.data.name }}
                              </template>
                            </column>

                            <column field="sketch">
                              <template #body="slotProps">
                                <span class="p-column-title">Eskiis</span>
                                {{ slotProps.data.sketch }}
                              </template>
                            </column>

                            <column field="pre">
                              <template #body="slotProps">
                                <span class="p-column-title">Eelprojekt</span>
                                {{ slotProps.data.pre }}
                              </template>
                            </column>

                            <column field="mainproject">
                              <template #body="slotProps">
                                <span class="p-column-title">Põhiprojekt</span>
                                {{ slotProps.data.mainproject }}
                              </template>
                            </column>

                            <column field="workproject">
                              <template #body="slotProps">
                                <span class="p-column-title">Tööprojekt</span>
                                {{ slotProps.data.workproject }}
                              </template>
                            </column>

                            <column field="research">
                              <template #body="slotProps">
                                <span class="p-column-title">Uuringud</span>
                                {{ slotProps.data.research }}
                              </template>
                            </column>

                            <column field="all" body-class="text-right">
                              <template #body="slotProps">
                                <span class="p-column-title">Kokku</span>
                                {{ slotProps.data.all }}
                              </template>
                            </column>
                          </data-table>
                        </template>
                      </data-table>
                    </div>
                  </tab-panel>
                </tab-view>
            </div>

            <div
                v-if="project.can_pick_tasks && !ProjectUserStatus.isConfirmedTeam(projectUser.status.id) && ProjectUserRole.isSpecialist(projectUser.role.id)"
                class="my-8 md:my-12">
              <h1 class="mb-6 text-2xl font-bold leading-tight text-black md:text-4xl">Vali ülesanded
                <span
                    v-tooltip.top="
                          '<div>' +
                          'Vali ülesanded, mida projekti valmimisel kindlasti tegema pead. Ülesandeid saad kommenteerida ja nende maksumust muuta. ' +
                          'Soovitame püsida etteantud hinna raamides ning tegevuste märkimisel ja summade muutmisel mõtle eelkõige ajaarvestusele. ' +
                          'Kõik etapis toodud ülesanded peavad võimaldama antud etapi korrektselt üle anda. ' +
                          'Kui tegevus ei vasta sinu kategooria ülesannetele, siis pane see kommentaarina ülesande juurde kirja. ' +
                          '</div>'"
                    class="pi pi-info-circle text-gray-600"
                    escape="false"
                ></span>
              </h1>

              <tab-view :active-index="active" @tab-change="changeActiveTabChooseTasks" ref="chooseTasksTabView">
                <tab-panel v-for="phase in project.phases" :key="phase.id">
                  <template slot="header">
                    <h3 class="text-lg">{{ phase.name }}</h3>
                  </template>

                  <div class="py-6 text-gray-900">
                    <div class="flex flex-wrap justify-between">
                      <div class="w-full md:w-1/2 lg:w-1/6">
                        <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Ülesande nimetus</h4>
                      </div>

                      <div class="w-full md:w-1/2 lg:w-2/6">
                        <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Kirjeldus</h4>
                      </div>

                      <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                        <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Tähtaeg</h4>
                      </div>

                      <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                        <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Pakutud hind</h4>
                      </div>

                      <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                        <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Täpsustatud hind</h4>
                      </div>
                    </div>

                    <div
                        v-for="(task) in recipes.find(a => a.phase_id === phase.id)?.assignments"
                        :key="task.id"
                        class="bg-white py-4 mb-3 rounded-lg shadow-lg"
                        :class="task.forLead ? 'bg-blue-50' : ''"
                    >
                      <div class="flex flex-wrap items-center justify-between">
                        <div class="flex items-center w-full md:w-1/2 lg:w-1/6 px-6">
                          <div class="flex items-center">
                            <div class="flex items-center mr-4">
                              <input-switch v-model="task.enabled" />
                            </div>
                            <div class="flex-1 font-semibold">{{ task.title }}</div>
                          </div>
                        </div>

                        <div class="px-6 py-1 md:w-1/4 lg:w-2/6">
                                        <textarea
                                            v-model="task.comment"
                                            placeholder="Kirjelda tegevus"
                                            style="display: block;"
                                            rows="1"
                                            cols="35"
                                            maxlength="500"
                                            class="rounded p-1"
                                        />
                        </div>

                        <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                          <h4 class="px-6 py-2">{{ task.date }}</h4>
                        </div>

                        <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                          <h4 v-if="task.estimatedPrice" class="px-6 py-2">{{ task.estimatedPrice }} €</h4>
                        </div>

                        <div class="w-full md:w-1/4 lg:w-1/6">
                          <input-number
                              :placeholder="task.price"
                              v-model="task.price"
                              :inputClass="task.price === task.estimatedPrice ? 'text-gray-600 text-right' : 'text-right'"
                              mode="currency"
                              currency="EUR"
                              locale="et-EE"
                              @focus="initPriceChange(task)"
                              @focusout="endPriceChange(task)"
                              :min="0"
                              :maxFractionDigits="0"
                          />
                        </div>
                      </div>
                    </div>

                    <div v-if="totalEstimatedPrice(recipes.find(a => a.phase_id === phase.id).assignments) || totalActualPrice(recipes.find(a => a.phase_id === phase.id).assignments)"
                         class="flex flex-wrap justify-between bg-white py-4 mb-3 rounded-lg shadow-lg">
                      <div class="w-full md:w-1/2 lg:w-1/6">
                        <h4 class="px-6 py-2 font-semibold">Kokku</h4>
                      </div>

                      <div class="w-full md:w-1/2 lg:w-3/6">
                        <h4 class="px-6 py-2 text-sm text-blue-500 uppercase"></h4>
                      </div>

                      <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                        <h4 v-if="totalEstimatedPrice(recipes.find(a => a.phase_id === phase.id).assignments)" class="px-6 py-2 font-semibold">{{ totalEstimatedPrice(recipes.find(a => a.phase_id === phase.id).assignments) }} €</h4>
                      </div>

                      <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                        <h4 v-if="totalActualPrice(recipes.find(a => a.phase_id === phase.id).assignments)" class="px-6 py-2 font-semibold">{{ totalActualPrice(recipes.find(a => a.phase_id === phase.id).assignments) }} € </h4>
                      </div>
                    </div>

                    <div
                        :class="newTaskExpanded ? 'bg-white shadow-lg' : ''"
                        class=" py-4 px-6 rounded-lg transition duration-300"
                    >
                      <button class="flex items-center" @click="newTaskExpanded = !newTaskExpanded">
                        <div
                            class="flex items-center justify-center w-6 h-6 text-white bg-blue-500 rounded-full mr-4 shadow-md">
                          <span class="pi pi-plus font-semibold"></span>
                        </div>
                        <div class="font-semibold">Muu tegevus</div>
                      </button>

                      <transition name="accordion" mode="out-in">
                        <div v-if="newTaskExpanded" key="newTaskExpanded">
                          <div class="py-4">
                            <div class="flex flex-wrap -mx-6">
                              <div class="w-full md:w-1/2 lg:w-1/3 px-6 py-4">
                                <div class="p-float-label">
                                  <dropdown
                                      id="newTaskType"
                                      v-model="newTaskType"
                                      :options="recipes.find(a => a.phase_id === phase.id).assignments"
                                      option-label="title"
                                      class="w-full"
                                  />
                                  <label for="newTaskType" class="text-blue-500 uppercase">Vali
                                    tegevuse tüüp</label>
                                </div>
                              </div>

                              <div class="w-full md:w-1/2 lg:w-2/3 px-6 py-4">
                                <div class="p-float-label">
                                  <input-text
                                      id="newTaskComment"
                                      placeholder=" "
                                      v-model="newTaskComment"
                                      class="w-full"
                                  />
                                  <label for="newTaskComment" class="text-blue-500 uppercase">Kommentaar</label>
                                </div>
                              </div>
                            </div>

                            <div class="flex flex-wrap justify-between -mx-6">
                              <div class="w-full md:w-1/2 lg:w-1/3 px-6 py-4">
                                <div class="p-float-label">
                                  <input-number
                                      id="newTaskPrice"
                                      placeholder=" "
                                      v-model="newTaskPrice"
                                      class="w-full"
                                      autocomplete="off"
                                      :use-grouping="false"
                                  />
                                  <label for="newTaskPrice"
                                         class="text-blue-500 uppercase">Hind</label>
                                </div>
                              </div>

                              <div class="w-full md:w-1/2 lg:w-1/3 flex justify-end px-6 py-4">
                                <button
                                    class="btn btn-sm uppercase text-xs mx-4"
                                    @click="clearNewTask"
                                >Kustuta
                                </button>

                                <button
                                    :disabled="(newTaskType || newTaskPrice) === null"
                                    class="btn btn-sm uppercase text-xs bg-blue-200"
                                    @click="saveNewTask"
                                >Salvesta
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                </tab-panel>
              </tab-view>

              <button
                  @click="confirmTasks"
                  ref="confirmTasksButton"
                  class="uppercase text-white bg-blue-500 btn w-full sm:w-auto md:px-24">
                Kinnita ülesanded
              </button>
            </div>

            <div
              v-if="isInTasksPickState"
              class="my-8 md:my-12">
            <h1 class="mb-6 text-2xl font-bold leading-tight text-black md:text-4xl">Valitud ülesanded</h1>

            <tab-view :active-index="active" @tab-change="changeActiveTabChosenTasks" ref="chosenTasksTabView">
              <tab-panel v-for="phase in project.phases" :key="phase.id">
                <template slot="header">
                  <h3 class="text-lg">{{ phase.name }}</h3>
                </template>

                <div>
                  <div>
                    <div class="flex flex-wrap justify-between px-6 py-3">

                      <div class="w-full md:w-1/2 lg:w-1/12 self-center" @click="togglePickTasksDetail()">
                        <span v-if="pickTasksDetailOpen" class="pi pi-angle-down text-blue-500 text-xl"></span>
                        <span v-else class="pi pi-angle-right text-blue-500 text-xl"></span>
                      </div>

                      <div class="w-full md:w-1/2 lg:w-5/12" @click="togglePickTasksDetail()">
                        <h4 class="mb-1 text-sm text-blue-500 uppercase">Nimi</h4>
                        <p class="text-lg font-semibold">{{ project.area_name }} {{ project.phases.find(p => p.id === phase.id)?.name }}</p>
                      </div>

                      <div class="w-full md:w-1/2 lg:w-2/12" @click="togglePickTasksDetail()">
                        <h4 class="mb-1 text-sm text-blue-500 uppercase">Tähtaeg</h4>
                        <p class="text-lg">{{ tasks.find(a => a.phase_id === phase.id)?.assignments[0]?.date }}</p>
                      </div>

                      <div class="w-full md:w-1/2 lg:w-2/12" @click="togglePickTasksDetail()">
                        <h4 class="mb-1 text-sm text-blue-500 uppercase text-right">Pakutud hind</h4>
                        <p class="text-lg text-right">{{ pickTasksActualPriceTotal.find(a => a.phase_id === phase.id).estimatedPrice }} €</p>
                      </div>

                      <div class="w-full md:w-1/2 lg:w-2/12">
                        <h4 class="mb-1 text-sm text-blue-500 uppercase text-right">Täpsustatud hind</h4>
                        <p class="text-lg text-right">
                          <input-number
                              v-model="pickTasksActualPriceTotal.find(a => a.phase_id === phase.id).actualPrice"
                              :inputClass="totalActualPrice(tasks.find(a => a.phase_id === phase.id)?.assignments) === totalEstimatedPrice(tasks.find(a => a.phase_id === phase.id)?.assignments) ? 'text-gray-600 text-right' : 'text-right'"
                              mode="currency"
                              currency="EUR"
                              locale="et-EE"
                              @focus="initTotalPriceChange(phase.id)"
                              @focusout="endTotalPriceChange(phase.id)"
                              :min="0"
                              :maxFractionDigits="0"
                          />
                        </p>
                      </div>
                    </div>
                  </div>

                  <div v-if="pickTasksDetailOpen" class="py-6 text-gray-900">
                    <div class="flex flex-wrap justify-between">
                      <div class="w-full md:w-1/2 lg:w-1/6">
                        <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Ülesande nimetus</h4>
                      </div>

                      <div class="w-full md:w-1/2 lg:w-2/6">
                        <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Kirjeldus</h4>
                      </div>

                      <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                        <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Tähtaeg</h4>
                      </div>

                      <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                        <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Pakutud hind</h4>
                      </div>

                      <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                        <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Täpsustatud hind</h4>
                      </div>
                    </div>

                    <div
                        v-for="(task) in tasks.find(a => a.phase_id === phase.id)?.assignments"
                        :key="task.id"
                        class="bg-white py-4 mb-3 rounded-lg shadow-lg"
                        :class="task.forLead ? 'bg-blue-50' : ''"
                    >
                      <div class="flex flex-wrap items-center justify-between"
                           :class="!task.confirmed ? 'p-disabled' : ''">
                        <div class="flex items-center w-full md:w-1/2 lg:w-1/6 px-6">
                          <div class="flex items-center">
                            <div class="flex items-center mr-4">
                              <input-switch v-model="task.enabled" />
                            </div>
                            <div class="flex-1 font-semibold">{{ task.title }}</div>
                          </div>
                        </div>

                        <div class="px-6 py-1 md:w-1/4 lg:w-2/6">
                                          <textarea
                                              v-model="task.comment"
                                              placeholder="Kirjelda tegevus"
                                              style="display: block;"
                                              rows="1"
                                              cols="35"
                                              maxlength="500"
                                              class="rounded p-1"
                                          />
                        </div>

                        <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                          <h4 class="px-6 py-2">{{ task.date }}</h4>
                        </div>

                        <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                          <h4 v-if="task.estimatedPrice" class="px-6 py-2">{{ task.estimatedPrice }} €</h4>
                        </div>

                        <div class="w-full md:w-1/4 lg:w-1/6">
                          <input-number
                              v-model="task.price"
                              :inputClass="task.price === task.estimatedPrice ? 'text-gray-600 text-right' : 'text-right'"
                              mode="currency"
                              currency="EUR"
                              locale="et-EE"
                              @focus="initPriceChange(task)"
                              @focusout="endPriceChange(task)"
                              :min="0"
                              :maxFractionDigits="0"
                          />
                        </div>
                      </div>
                    </div>

                    <div v-if="totalEstimatedPrice(tasks.find(a => a.phase_id === phase.id)?.assignments) || totalActualPrice(tasks.find(a => a.phase_id === phase.id)?.assignments)" class="flex flex-wrap justify-between bg-white py-4 mb-3 rounded-lg shadow-lg">
                      <div class="w-full md:w-1/2 lg:w-1/6">
                        <h4 class="px-6 py-2 font-semibold">Kokku</h4>
                      </div>

                      <div class="w-full md:w-1/2 lg:w-3/6">
                        <h4 class="px-6 py-2 text-sm text-blue-500 uppercase"></h4>
                      </div>

                      <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                        <h4 v-if="totalEstimatedPrice(tasks.find(a => a.phase_id === phase.id)?.assignments)" class="px-6 py-2 font-semibold">{{ totalEstimatedPrice(tasks.find(a => a.phase_id === phase.id)?.assignments) }} €</h4>
                      </div>

                      <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                        <h4 v-if="totalActualPrice(tasks.find(a => a.phase_id === phase.id)?.assignments)" class="px-6 py-2 font-semibold">{{ totalActualPrice(tasks.find(a => a.phase_id === phase.id)?.assignments) }} € </h4>
                      </div>
                    </div>

                    <div
                        :class="newTaskExpanded ? 'bg-white shadow-lg' : ''"
                        class=" py-4 px-6 rounded-lg transition duration-300"
                    >
                      <button class="flex items-center" @click="newTaskExpanded = !newTaskExpanded">
                        <div
                            class="flex items-center justify-center w-6 h-6 text-white bg-blue-500 rounded-full mr-4 shadow-md">
                          <span class="pi pi-plus font-semibold"></span>
                        </div>
                        <div class="font-semibold">Muu tegevus</div>
                      </button>

                      <transition name="accordion" mode="out-in">
                        <div v-if="newTaskExpanded" key="newTaskExpanded">
                          <div class="py-4">
                            <div class="flex flex-wrap -mx-6">
                              <div class="w-full md:w-1/2 lg:w-1/3 px-6 py-4">
                                <div class="p-float-label">
                                  <dropdown
                                      id="newTaskType"
                                      v-model="newTaskType"
                                      :options="recipes.find(a => a.phase_id === phase.id).assignments"
                                      option-label="title"
                                      class="w-full">
                                    <template #value="slotProps">
                                      <div v-if="slotProps.value"
                                           class="p-1"
                                           :class=" slotProps.value.forLead ? 'bg-blue-50' : ''" >
                                        <span class="p-1">{{slotProps.value.title}}</span>
                                      </div>
                                      <div v-else class="p-3">
                                          {{slotProps.placeholder}}
                                      </div>
                                    </template>
                                    <template #option="slotProps">
                                      <div
                                          class="p-1"
                                          :class="slotProps.option !== newTaskType && slotProps.option.forLead ? 'bg-blue-50' : ''">
                                        <span class="p-1">{{slotProps.option.title}}</span>
                                      </div>
                                    </template>
                                  </dropdown>
                                  <label for="newTaskType" class="text-blue-500 uppercase">Vali
                                    tegevuse tüüp</label>
                                </div>
                              </div>

                              <div class="w-full md:w-1/2 lg:w-2/3 px-6 py-4">
                                <div class="p-float-label">
                                  <input-text
                                      id="newTaskComment"
                                      placeholder=" "
                                      v-model="newTaskComment"
                                      class="w-full"
                                  />
                                  <label for="newTaskComment" class="text-blue-500 uppercase">Kommentaar</label>
                                </div>
                              </div>
                            </div>

                            <div class="flex flex-wrap justify-between -mx-6">
                              <div class="w-full md:w-1/2 lg:w-1/3 px-6 py-4">
                                <div class="p-float-label">
                                  <input-number
                                      id="newTaskPrice"
                                      placeholder=" "
                                      v-model="newTaskPrice"
                                      class="w-full"
                                      autocomplete="off"
                                      :use-grouping="false"
                                  />
                                  <label for="newTaskPrice"
                                         class="text-blue-500 uppercase">Hind</label>
                                </div>
                              </div>

                              <div class="w-full md:w-1/2 lg:w-1/3 flex justify-end px-6 py-4">
                                <button
                                    class="btn btn-sm uppercase text-xs mx-4"
                                    @click="clearNewTask"
                                >Kustuta
                                </button>

                                <button
                                    :disabled="(newTaskType || newTaskPrice) === null"
                                    class="btn btn-sm uppercase text-xs bg-blue-200"
                                    @click="saveNewTask"
                                >Salvesta
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                </div>
              </tab-panel>
            </tab-view>

            <button
                @click="changeTasks"
                ref="changeTasksButton"
                class="uppercase text-white bg-blue-500 btn w-full sm:w-auto md:px-24 mt-5">
              Kinnita muudatused
            </button>
          </div>

            <div v-if="(ProjectUserStatus.isNotMember(projectUser.status.id) || projectUser.status.id === ProjectUserStatus.INVITED) && ProjectUserRole.isSpecialist(projectUser.role.id)"
                 class="my-8 md:my-12">
                <h1 class="text-2xl font-bold leading-tight text-black md:text-4xl mb-6">Minu ülesanded</h1>

                <tab-view>
                    <tab-panel>
                        <template slot="header">
                            <h3 class="text-lg">Eskiis</h3>
                        </template>

                        <div class="py-6 text-gray-900">
                            <div class="flex flex-wrap justify-between">
                                <div class="w-full md:w-1/2 lg:w-1/6">
                                  <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Ülesande nimetus</h4>
                                </div>

                                <div class="w-full md:w-1/2 lg:w-2/6">
                                  <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Kommentaar</h4>
                                </div>

                                <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                                  <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Tähtaeg</h4>
                                </div>

                                <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                                  <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Esialgne maksumus</h4>
                                </div>

                                <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                                  <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Ülesande maksumus</h4>
                                </div>
                            </div>

                            <div class="relative">
                                <div class="absolute inset-0 bg-gradient-to-t from-gray-100"></div>
                                <div
                                    v-for="n in 3"
                                    :key="n"
                                    :class="{ 'opacity-50': n === 2, 'opacity-25': n === 3 }"
                                    class="bg-white py-2 mb-3 rounded-md shadow-lg"
                                >
                                    <div class="flex flex-wrap items-center justify-between">
                                        <div class="w-full md:w-1/2 lg:w-3/6 px-6 py-2">
                                            <div class="md:max-w-sm h-4 rounded bg-gray-200"></div>
                                        </div>

                                        <div class="w-full md:w-1/4 lg:w-1/6 px-6 py-2">
                                            <div class="h-4 rounded bg-gray-200"></div>
                                        </div>

                                        <div class="w-full md:w-1/4 lg:w-1/6 px-6 py-2">
                                            <div class="h-4 rounded bg-gray-200"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </tab-panel>

                    <tab-panel v-for="n in 3" :key="n" disabled>
                        <template slot="header">
                            <h3 v-if="n === 1" class="text-lg">Eelprojekt</h3>
                            <h3 v-if="n === 2" class="text-lg">Põhiprojekt</h3>
                            <h3 v-if="n === 3" class="text-lg">Tööprojekt</h3>
                        </template>
                    </tab-panel>
                </tab-view>
            </div>

            <div
                v-if="ProjectUserStatus.isConfirmedTeam(projectUser.status.id)
                  && ProjectUserRole.isSpecialist(projectUser.role.id)
                  && ProjectStatus.isTasksFixedStatuses(project.status.id)"
                class="my-8 md:my-12">
                <div class="flex flex-wrap items-end justify-between mb-6">
                    <div>
                        <h1 class="text-2xl font-bold leading-tight text-black md:text-4xl">Minu ülesanded
                          <span v-if="project.status.id === ProjectStatus.ACTIVE"
                              v-tooltip.top="
                                  '<div>' +
                                  'Märgi ülesande ees olevasse kasti linnuke juhul, kui antud ülesanne on täielikult tehtud. ' +
                                  'Märgitud ülesannete alusel tehakse etappide väljamakseid.' +
                                  '</div>'"
                              class="pi pi-info-circle text-gray-600"
                              escape="false">
                          </span>
                        </h1>

                        <router-link
                            v-if="project.status.id === ProjectStatus.ACTIVE"
                            :to="`/project/${projectUser.id}/add-task/${activeTabKey}`"
                            class="mt-4 text-orange-400 bg-orange-200 btn-sm rounded-full"
                        >
                            <span class="mr-3 text-xs font-bold pi pi-plus"></span>
                            Esita lisatöö
                        </router-link>
                    </div>

                    <div class="w-full sm:w-auto my-2">
                        <h4 class="text-sm text-right text-blue-500 uppercase">Tehtud tööd</h4>

                        <div class="w-full sm:w-32 my-2">
                            <div class="flex justify-between text-sm font-semibold mb-1">
                                <div>{{ myTasksCompletedTotal }}</div>
                                <div>{{ myTasksTotal }}</div>
                            </div>
                            <progress-bar :value="myTasksCompletedTotal / myTasksTotal * 100" :show-value="false"
                                          class="w-full h-2" />
                        </div>
                    </div>
                </div>

                <tab-view @tab-change="changeActiveTab" ref="doneTasksTabView">
                    <tab-panel v-for="phase in project.phases" :key="phase.id">
                        <template slot="header">
                            <h3 class="text-lg">{{ phase.name }}</h3>
                        </template>

                        <div class="py-6 text-gray-900">
                            <div class="flex flex-wrap justify-between">
                                <div class="w-full md:w-1/2 lg:w-1/6">
                                    <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Ülesande nimetus</h4>
                                </div>

                                <div class="w-full md:w-1/2 lg:w-2/6">
                                  <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Kommentaar</h4>
                                </div>

                                <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                                    <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Tähtaeg</h4>
                                </div>

                                <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                                  <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Esialgne maksumus</h4>
                                </div>

                                <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                                    <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Ülesande maksumus</h4>
                                </div>
                            </div>

                            <div
                                v-for="task in tasks.find(a => a.phase_id === phase.id)?.assignments"
                                :key="task.id"
                                class="bg-white py-1 mb-3 rounded-md shadow-lg"
                                :class="task.forLead ? 'bg-blue-50' : ''"
                            >
                                <div class="flex flex-wrap items-center justify-between"
                                     :class="!task.confirmed || ProjectUserStatus.TASKS_COMPLETED === projectUser.status.id ? 'p-disabled' : ''">
                                    <div class="flex items-center w-full md:w-1/2 lg:w-1/6 px-6">
                                        <div class="flex items-center">
                                            <div v-if="project && project.started" class="flex items-center mr-4">
                                                <checkbox v-model="task.completed" binary/>
                                            </div>
                                            <div class="flex-1 font-semibold">{{ task.title }}</div>
                                        </div>
                                    </div>

                                    <div class="w-full md:w-1/4 lg:w-2/6 text-left">
                                      <textarea v-if="task.comment"
                                                :value="task.comment"
                                                disabled
                                                style="display: block;"
                                                rows="2"
                                                cols="40"
                                                maxlength="500"
                                                class="rounded p-1"
                                      />
                                    </div>

                                    <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                                        <h4 class="px-6 py-2">{{ task.date }}</h4>
                                    </div>

                                    <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                                      <h4 v-if="task.estimatedPrice" class="px-6 py-2">{{ task.estimatedPrice }} €</h4>
                                    </div>

                                    <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                                        <h4 class="px-6 py-2">{{ task.price }} €</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </tab-panel>
                    <button v-if="project && project.started && ProjectUserStatus.TASKS_COMPLETED !== projectUser.status.id"
                            ref="submitTasksButton"
                            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded my-3"
                            @click="submitTasks">Salvesta
                    </button>
                </tab-view>
            </div>

          <div v-if="project && ProjectUserRole.isTeamLead(projectUser.role.id) && project.status.id === 8"
               class="my-8 md:my-12">
            <h1 class="text-2xl font-bold leading-tight text-black md:text-4xl mb-6">Tähtaeg</h1>

            <div
                v-for="pPhase in project.all_project_phases"
                :key="pPhase.id"
                class="bg-white py-1 mb-3 rounded-md shadow-lg">

              <div class="flex flex-wrap items-center justify-between">
                <div class="flex items-center w-full md:w-1/2 lg:w-1/2 px-6">
                  <div class="flex items-center">
                    <div class="flex-1 font-semibold">{{ pPhase.name }}</div>
                  </div>
                </div>

                <div class="flex items-center w-full md:w-1/2 lg:w-1/2 px-6">
                  <calendar
                      id="dueDate"
                      v-model="pPhase.due_at"
                      dateFormat="dd.mm.yy"
                      :min-date="new Date()"
                      :manual-input="false"
                      show-icon
                      icon="pi pi-calendar-plus"
                      :locale="$root.$data.et"
                      placeholder="dd.mm.yyyy"
                      class="w-full p-datepicker--dense"
                  />
                </div>
              </div>

            </div>
            <button
                ref="submitDueDatesButton"
                class="uppercase text-white bg-blue-500 btn w-full sm:w-auto md:px-24"
                @click="submitDueDates">Salvesta
            </button>

          </div>

            <div v-if="project && ((ProjectUserStatus.isNotMember(projectUser.status.id) || projectUser.status.id === ProjectUserStatus.INVITED) && projectUser.role.id === ProjectUserRole.TEAM_LEAD)"
                 class="my-8 md:my-12">
                <h1 class="text-2xl font-bold leading-tight text-black md:text-4xl mb-6">Meeskond</h1>

                <tab-view>
                    <tab-panel>
                        <template slot="header">
                            <h3 class="text-lg">Eskiis</h3>
                        </template>

                        <div class="py-6 text-gray-900">
                            <div class="flex flex-wrap">
                                <div class="w-full md:w-1/2 lg:w-3/5">
                                    <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Meeskond</h4>
                                </div>
                                <div class="flex flex-wrap w-full md:w-1/2 lg:w-2/5 justify-between">
                                    <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Eskiisi ülesanded</h4>
                                    <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Kõik ülesanded</h4>
                                </div>
                            </div>

                            <div class="relative">
                                <div class="absolute inset-0 bg-gradient-to-t from-gray-100"></div>
                                <div
                                    v-for="n in 3"
                                    :key="n"
                                    :class="{ 'opacity-50': n === 2, 'opacity-25': n === 3 }"
                                    class="bg-white py-2 mb-3 rounded-lg shadow-lg"
                                >
                                    <div class="flex flex-wrap items-center justify-between">
                                        <div class="flex items-center w-full md:w-1/2 lg:w-3/6 px-6 py-2">
                                            <div class="w-12 h-12 mr-4 bg-gray-200 rounded-full"></div>
                                            <div class="flex-1 md:max-w-xs h-4 rounded bg-gray-200"></div>
                                        </div>

                                        <div class="w-full md:w-1/4 lg:w-1/6 px-6 py-2">
                                            <div class="h-4 rounded bg-gray-200"></div>
                                        </div>

                                        <div class="w-full md:w-1/4 lg:w-1/6 px-6 py-2">
                                            <div class="h-4 rounded bg-gray-200"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </tab-panel>

                    <tab-panel v-for="n in 3" :key="n" disabled>
                        <template slot="header">
                            <h3 v-if="n === 1" class="text-lg">Eelprojekt</h3>
                            <h3 v-if="n === 2" class="text-lg">Põhiprojekt</h3>
                            <h3 v-if="n === 3" class="text-lg">Tööprojekt</h3>
                        </template>
                    </tab-panel>
                </tab-view>
            </div>

            <div v-if="project
                       && (!ProjectUserRole.isDraftsman(projectUser.role.id) || (Area.PROJECT_MANAGER === projectUser.area.id))
                       && (ProjectUserRole.isClient(projectUser.role.id) || ((ProjectUserStatus.isActive(projectUser.status.id) && project.started) || project.can_lead))" class="my-8 md:my-12">
                <div class="flex flex-wrap items-end justify-between mb-6">
                    <div>
                        <h1 class="text-2xl font-bold leading-tight text-black md:text-4xl">Meeskond
                          <span
                              v-if="ProjectStatus.isProjectManagerViableStopStatuses(project.status.id)"
                              v-tooltip.top="
                                '<div>' +
                                'Siin näed, kes Sinu valitud meeskonnaliikmetest on oma ülesanded ära valinud ja kes mitte ' +
                                '(valitud üleanded avanevad, kui klikkad inimese lahtri peal). ' +
                                'Siin kuvatakse kõik inimesed, keda süsteem antud projekti pakkus.' +
                                '</div>'"
                              class="pi pi-info-circle text-gray-600"
                              escape="false"
                          ></span>
                          <span
                              v-if="ProjectStatus.ACTIVE === project.status.id && ProjectUserRole.TEAM_LEAD === projectUser.role.id"
                              v-tooltip.top="
                                '<div>' +
                                'Siin näed projekti valitud meeskonnaliikmeid ja nende poolt valitud ülesandeid etappide kaupa. ' +
                                'Kui keegi on mõnes etapis esitanud lisatöö, kuvatakse need samuti siin vaates ning Sul on ' +
                                'võimalus neid peale tellijaga kooskõlastamist kas kinnitada või kustutada.' +
                                '</div>'"
                              class="pi pi-info-circle text-gray-600"
                              escape="false"
                          ></span>
                          <span
                              v-if="ProjectStatus.ACTIVE === project.status.id && ProjectUserRole.CLIENT === projectUser.role.id"
                              v-tooltip.top="
                                '<div>' +
                                'Siin näed projekti valitud meeskonnaliikmeid ja nende poolt valitud ülesandeid etappide kaupa. ' +
                                'Kui keegi on mõnes etapis esitanud lisatöö, kuvatakse need samuti siin.' +
                                '</div>'"
                              class="pi pi-info-circle text-gray-600"
                              escape="false"
                          ></span>
                          <span
                              v-if="ProjectStatus.ACTIVE === project.status.id && ProjectUserRole.CLIENT_TEAM_LEAD === projectUser.role.id"
                              v-tooltip.top="
                                '<div>' +
                                'Siin näed projekti valitud meeskonnaliikmeid ja nende poolt valitud ülesandeid etappide kaupa. '+
                                'Kui keegi on mõnes etapis esitanud lisatöö, kuvatakse need samuti siin vaates ning Sul on ' +
                                'võimalus neid kas kinnitada või kustutada.' +
                                '</div>'"
                              class="pi pi-info-circle text-gray-600"
                              escape="false"
                          ></span>
                        </h1>
                        <h2 v-if="ProjectStatus.isProjectManagerViableStopStatuses(project.status.id)">Esile on tõstetud projekteerijad, kes on antud projekti vastu huvi üles näidanud</h2>

                        <router-link
                            v-if="ProjectUserRole.isTeamLead(projectUser.role.id) && ProjectStatus.isInviteSpecialistStatuses(project.status.id)"
                            :to="`/project/${projectUser.id}/add-specialist`"
                            class="mt-4 text-orange-400 bg-orange-200 btn-sm rounded-full"
                        >
                            <span class="mr-3 text-xs font-bold pi pi-plus"></span>
                            Kutsu uus spetsialist
                        </router-link>
                    </div>

                    <div class="w-full sm:w-32 my-2">
                        <div class="flex justify-between text-sm font-semibold mb-1">
                            <div>{{ teamTasksActiveTotal }}</div>
                            <div>{{ teamTasksTotal }}</div>
                        </div>
                        <progress-bar
                            :value="teamTasksActiveTotal / teamTasksTotal * 100"
                            :show-value="false"
                            class="w-full h-2"
                        />
                    </div>
                </div>

                <tab-view>
                    <tab-panel v-for="phase in project.all_project_phases" :key="phase.id">
                        <template slot="header">
                            <h3 class="text-lg">{{ phase.name }}</h3>
                        </template>

                        <div class="py-6">
                            <div class="flex flex-wrap">
                                <div class="w-full md:w-1/2 lg:w-3/5">
                                    <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Meeskond</h4>
                                </div>
                                <div class="flex flex-wrap w-full md:w-1/2 lg:w-2/5 justify-between">
                                    <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">{{ phase.name }}i ülesanded</h4>
                                    <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Kõik ülesanded</h4>
                                </div>
                            </div>

                            <template v-for="(person, i) in teamList.find(tl => tl.phaseId === phase.id).team">
                                <div
                                    :key="phase.id + '_' + i + '_'+ person.name "
                                    class="bg-white py-4 mb-3 rounded-lg shadow-lg flex flex-wrap items-center"
                                >
                                    <div class="flex w-full md:w-1/2 lg:w-3/5 items-center px-6">
                                        <button
                                            v-if="(person.tasks && person.tasks.length) || (person.additionalTasks && person.additionalTasks.length)"
                                            class="w-8 h-8 mr-3 flex items-center justify-center"
                                            @click="teamListExpandedRows.splice(i,1, teamListExpandedRows[i] = !teamListExpandedRows[i])"
                                        >
                    <span
                        :class="teamListExpandedRows[i] ? 'pi-angle-up' : 'pi-angle-down'"
                        class="pi text-2xl text-gray-900"
                    ></span>
                                        </button>

                                        <div
                                            :style="'background: url(' + person.photo + ') no-repeat center center; background-size: cover;'"
                                            class="w-12 h-12 mr-4 bg-gray-300 rounded-full cursor-pointer"
                                            @click="showProfile(person.id)"
                                        >
                                        </div>
                                        <div :class="person.status.id === ProjectUserStatus.INVITED ? 'p-disabled' : ''">
                                            <h4 class="font-semibold text-gray-900 text-lg">{{ person.name }}</h4>
                                        </div>
                                        <div :class="person.status.id === ProjectUserStatus.INVITED ? 'p-disabled' : ''">
                                            <h4 class="px-2 text-gray-400 text-lg uppercase">{{ person.areaShort }}</h4>
                                        </div>
                                    </div>

                                    <div class="flex flex-wrap w-full md:w-1/2 lg:w-2/5 justify-between">
                                        <div class="w-full sm:w-40 px-6 my-2">
                                            <div class="flex justify-between text-sm font-semibold mb-1"
                                                 :class="person.status.id === ProjectUserStatus.INVITED ? 'p-disabled' : ''">
                                                <div>{{
                                                        person.tasks.filter(task => task.completed && task.area_phase.phase_id === phase.id).length
                                                    }}
                                                </div>
                                                <div>{{
                                                        person.tasks.filter(task => task.enabled && task.area_phase.phase_id === phase.id).length
                                                    }}
                                                </div>
                                            </div>
                                            <progress-bar
                                                :value="person.tasks.filter(task => task.completed && task.area_phase.phase_id === phase.id).length / person.tasks.filter(task => task.enabled && task.area_phase.phase_id === phase.id).length * 100"
                                                :show-value="false" class="w-full h-2" />
                                        </div>

                                        <div class="w-full sm:w-40 px-6 my-2">
                                            <div class="flex justify-between text-sm font-semibold mb-1"
                                                 :class="person.status.id === ProjectUserStatus.INVITED ? 'p-disabled' : ''">
                                                <div>{{
                                                        flatTeam.find(p => p.id === person.id).tasks.filter(task => task.completed).length
                                                    }}
                                                </div>
                                                <div>{{ flatTeam.find(p => p.id === person.id).tasks.length }}</div>
                                            </div>
                                            <progress-bar
                                                :value="flatTeam.find(p => p.id === person.id).tasks.filter(task => task.completed).length / flatTeam.find(p => p.id === person.id).tasks.length * 100"
                                                :show-value="false"
                                                class="w-full h-2"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <transition name="accordion" mode="out-in" v-if="teamListExpandedRows[i]"
                                            :key="'expanded_' + i + '_' + teamListExpandedRows[i]">
                                    <div
                                        v-if="teamListExpandedRows[i]"
                                        :key="'expanded_' + i + '_' + teamListExpandedRows[i]"
                                        class="w-full">
                                        <div class="pt-2 pb-6 md:pb-10">
                                            <template v-if="person.tasks && person.tasks.length">
                                                <div class="flex flex-wrap">
                                                    <div class="flex-1">
                                                        <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Ülesande
                                                            nimetus</h4>
                                                    </div>
                                                    <div class="flex-1">
                                                      <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Kommentaar</h4>
                                                    </div>
                                                    <div class="text-right">
                                                        <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Tähtaeg</h4>
                                                    </div>
                                                    <div class="text-right">
                                                      <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Esialgne maksumus</h4>
                                                    </div>
                                                    <div class="text-right">
                                                      <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Ülesande maksumus</h4>
                                                    </div>
                                                </div>

                                                <div
                                                    v-for="task in person.tasks"
                                                    :key="task.id"
                                                    class="bg-white py-1 mb-3 rounded-md shadow-lg flex flex-wrap items-center"
                                                    v-bind:class="{ 'text-gray-400': !task.enabled }"
                                                >
                                                    <div class="w-full flex flex-wrap items-center justify-between">
                                                        <div class="flex items-center w-full md:w-1/2 lg:w-1/6 px-6">
                                                            <div class="flex items-center">
                                                                <div v-if="project.started && task.enabled" class="flex items-center mr-4">
                                                                    <checkbox v-model="task.completed" binary class="p-disabled"/>
                                                                </div>
                                                                <div class="flex-1 font-semibold">{{ task.name }}</div>
                                                            </div>
                                                        </div>

                                                        <div class="w-full md:w-1/4 lg:w-2/6 text-left">
                                                          <textarea v-if="task.comments"
                                                            :value="task.comments"
                                                            disabled
                                                            style="display: block;"
                                                            rows="2"
                                                            cols="40"
                                                            maxlength="500"
                                                            class="rounded p-1"
                                                          />
                                                        </div>

                                                        <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                                                            <h4 class="px-6 py-2">{{ task.due_at }}</h4>
                                                        </div>

                                                        <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                                                          <h4 v-if="task.estimatedPrice" class="px-6 py-2">{{ task.estimatedPrice }} €</h4>
                                                        </div>

                                                        <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                                                          <h4 class="px-6 py-2">{{ task.price }} €</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="bg-white py-1 mb-3 rounded-md shadow-lg flex flex-wrap items-center">
                                                  <div class="w-full md:w-1/2 lg:w-1/6">
                                                    <h4 class="px-6 py-2 font-semibold">Kokku</h4>
                                                  </div>

                                                  <div class="w-full md:w-1/2 lg:w-3/6">
                                                    <h4 class="px-6 py-2 text-sm text-blue-500 uppercase"></h4>
                                                  </div>

                                                  <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                                                    <h4 v-if="totalEstimatedPrice(person.tasks)" class="px-6 py-2 font-semibold">{{ totalEstimatedPrice(person.tasks) }} €</h4>
                                                  </div>

                                                  <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                                                    <h4 v-if="totalActualPrice(person.tasks)" class="px-6 py-2 font-semibold">{{ totalActualPrice(person.tasks) }} € </h4>
                                                  </div>
                                                </div>
                                            </template>

                                            <template v-if="person.additionalTasks && person.additionalTasks.length
                                              && (ProjectUserRole.isTeamLead(projectUser.role.id) || ProjectUserRole.isClient(projectUser.role.id))">
                                                <div class="flex flex-wrap">
                                                    <div class="flex-1">
                                                        <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Kinnitamata</h4>
                                                    </div>
                                                    <div class="flex-1">
                                                      <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Kommentaar</h4>
                                                    </div>
                                                    <div class="text-right">
                                                        <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Tähtaeg</h4>
                                                    </div>
                                                    <div class="text-right">
                                                      <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Esialgne maksumus</h4>
                                                    </div>
                                                    <div class="text-right">
                                                      <h4 class="px-6 py-2 text-sm text-blue-500 uppercase">Ülesande maksumus</h4>
                                                    </div>
                                                </div>

                                                <div
                                                    v-for="task in person.additionalTasks"
                                                    :key="task.id"
                                                    class="bg-white py-1 mb-3 rounded-md shadow-lg flex flex-wrap items-center"
                                                >
                                                    <router-link
                                                        v-if="ProjectUserRole.isTeamLead(projectUser.role.id) && TaskStatus.NOT_CONFIRMED === task.status.id"
                                                        :to="'/project/' + $route.params.projectUserId + '/confirm-task/'+ task.id"
                                                        class="w-full">
                                                        <div class="w-full flex flex-wrap items-center justify-between">
                                                            <div class="flex items-center w-full md:w-1/2 lg:w-1/6 px-6">
                                                                <div class="font-semibold">{{ task.name }}</div>
                                                            </div>

                                                            <div class="w-full md:w-1/4 lg:w-2/6 text-left">
                                                              <textarea v-if="task.comments"
                                                                :value="task.comments"
                                                                disabled
                                                                style="display: block;"
                                                                rows="2"
                                                                cols="40"
                                                                maxlength="500"
                                                                class="rounded p-1"
                                                              />
                                                            </div>

                                                            <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                                                                <h4 class="px-6 py-2">{{ task.date }}</h4>
                                                            </div>

                                                            <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                                                              <h4 v-if="task.estimatedPrice" class="px-6 py-2">{{ task.estimatedPrice }} €</h4>
                                                            </div>

                                                            <div class="w-full md:w-1/4 lg:w-1/6 text-right">
                                                              <h4 class="px-6 py-2">{{ task.price }} €</h4>
                                                            </div>
                                                        </div>
                                                    </router-link>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </transition>
                            </template>
                        </div>
                    </tab-panel>
                </tab-view>
            </div>

            <div v-if="project && (ProjectUserRole.isClient(projectUser.role.id) && project.status !== null && project.status.id === ProjectStatus.ACTIVE)"
                 class="flex justify-center">
                <router-link
                    :to="`/project/${projectUser.id}/end`"
                    class="w-full text-white bg-orange-400 sm:w-80 btn">
                  Lõpeta projekt
                </router-link>
            </div>
        </user-layout>
    </div>
</template>

<script>
import moment from 'moment'
import UserLayout from './../Layouts/UserLayout'
import { mapGetters } from 'vuex';
import {getProjectRating} from "@/store/rating.api";
import {pushToProjectRating} from "@/routes";
import {confirmAll, changeAll, updateAll} from "../store/task.api";
import {getProjectOverview, getProjectWarnings, acceptContract, getProjectUser, getFile, toggleArea, toggleAreaPhase, updateDueDates, getContractExists, getProject} from "../store/project.api";
import {ProjectUserRole} from "../utils/projectUser.role";
import {ProjectUserStatus} from "../utils/projectUser.status";
import {ProjectStatus} from "../utils/project.status";
import {TaskStatus} from "../utils/task.status";
import {Phase} from "../utils/phase";
import {Area} from "../utils/area";
import Profile from './../components/Profile';
import {ProjectWarning} from "@/utils/project.warning";

export default {
    components: {
        UserLayout,
        Profile,
    },
    data() {
        return {
            hasContract: false,
            projectUser: {
              areaShort: '',
              id: -1,
              isContractAccepted: false,
              role: {
                id: null,
                name: null
              },
              status: {
                id: null,
                name: null
              }
            },
            project: {
                above_ground_floors: 0,
                address: '',
                area_name: '',
                area_price: 0,
                building_type: {},
                can_lead: false,
                can_pick_tasks: false,
                can_pick_teamlead: false,
                condition: null,
                created_at: '',
                energyclass: null,
                externalStuff: '',
                id: '',
                totalPrice: '',
                personalPrice: '',
                initial_price: '',
                name: '',
                number: '',
                permission: null,
                phases: [],
                phases_str: '',
                project_area: '',
                size: 0,
                start_date: null,
                started: false,
                status: {
                  id: -1,
                  created_at: null,
                  name: '',
                  subtitle: '',
                  updated_at: null
                },
                underground_floors: 0,
                //projectUserId: null

            },
            recipes: [],
            tasks: [],
            teamList: null,
            flatTeam: null,
            toast: null,

            active: 0,
            activeKey: null,
            activeTab: 0,
            activeTabKey: null,
            phase: null,
            privacyCheckbox: false,
            projectOverview: {},
            projectWarnings: [],
            tasksSelect: [
                {
                    id: 0,
                    enabled: false,
                    title: 'Hoone maht ja ruumiprogramm',
                    date: '28.03.2021',
                    price: 632,
                    comment: ''
                },
                {
                    id: 1,
                    enabled: true,
                    title: 'Lähtematerjalid ja kitsendused',
                    date: '29.03.2021',
                    price: 5327,
                    comment: 'Lorem ipsum'
                }
            ],
            overviewTableExpandedRows: [],
            fundingTableExpandedRows: [],
            newTaskExpanded: false,
            newTaskPrice: null,
            newPrice: null,
            newTaskComment: null,
            newTaskType: null,
            newTaskTypes: ['Tehnilise tingimuste vormistamine', '2', '3'],
            teamListExpandedRows: [],
            createTasks: [],
            showModal: false,
            memberId: null,
            renameMeExpandedRows: [],
            pickTasksActualPriceTotal: [],
            pickTasksDetailOpen: false,
        }
    },
    computed: {
      ProjectWarning() {
        return ProjectWarning
      },
        ...mapGetters({
            user: 'global/user',
            isAdmin: 'global/isAdmin',
        }),
        ProjectUserRole() {
          return ProjectUserRole;
        },
        ProjectUserStatus() {
          return ProjectUserStatus;
        },
        ProjectStatus() {
          return ProjectStatus;
        },
        TaskStatus() {
          return TaskStatus;
        },
        Phase() {
          return Phase;
        },
        Area() {
          return Area;
        },
        myTasksTotal() {
            if (this.tasks === null) {
              return null;
            }
            const tasks = Object.values(this.tasks.flatMap(apt => apt.assignments)).flat()
            return tasks?.length
        },
        myTasksCompletedTotal() {
            if (this.tasks === null) {
              return null;
            }
            const tasks = Object.values(this.tasks.flatMap(apt => apt.assignments)).flat().filter(task => task?.completed)
            return tasks?.length
        },
        teamTasksTotal() {
            if (this.tasks === null || this.tasks === undefined || this.tasks.length === 0) {
              return 0;
            }
            const tasks = Object.values(this.flatTeam).map(person => person?.tasks?.length > 0 ? person?.tasks?.filter(task => task)?.length : 0)
            return tasks.reduce((a, b) => a + b, 0)
        },
        teamTasksActiveTotal() {
            if (this.tasks === null || this.tasks === undefined || this.tasks.length === 0) {
              return 0;
            }
            const tasks = Object.values(this.flatTeam).map(person => person?.tasks?.length > 0 ? person?.tasks?.filter(task => task?.completed)?.length : 0)
            return tasks.reduce((a, b) => a + b, 0)
        },
        isInTasksPickState() {
          return this.project.can_pick_tasks && ProjectUserStatus.isConfirmedTeam(this.projectUser.status.id) && ProjectUserRole.isSpecialist(this.projectUser.role.id)
              && ProjectStatus.isInviteSpecialistStatuses(this.project.status.id);
        }
    },
    methods: {
        async loadProject() {
            const { data } = await getProject(this.$route.params.projectUserId);
            if (data) {
              if (data?.route) {
                await this.$router.push(data.route);
              } else {
                this.project = data?.project;
                this.fireEventIfProjectCompleted();
                this.privacyCheckbox = this.projectUser.isContractAccepted;
                this.recipes = data?.recipes;
                this.tasks = data?.tasks;
                Object.values(this.tasks).forEach(apt => {
                  apt.assignments.forEach(task => {
                    task.completed = !!(task.completed || task.completed === 1);
                  });
                })

                if (this.isInTasksPickState) {
                  this.resetTaskTotals();
                }

                this.teamList = data?.teamList;
                this.flatTeam = data?.flatTeam;
                this.toast = data?.toast;

                this.activeTabKey = this.project.phases[0].id;
                this.phase = this.project.phases[0];
              }
            }

            if (this.teamList) {
              this.teamListExpandedRows = new Array(this.teamList.length).fill(false);
            } else {
              this.teamListExpandedRows = {};
            }
            if (ProjectUserStatus.isConfirmedTeam(this.projectUser.status.id)) {
              this.createTasks = this.tasks
            } else {
              this.createTasks = this.recipes
            }

          getContractExists(this.projectUser.id).then(resp => {
            this.hasContract = Boolean(resp.data);
          });

          getProjectOverview(this.projectUser.id).then(resp => {
            this.projectOverview = resp.data;
          });
        },
        fireEventIfProjectCompleted() {
          if (this.project.status.id === 5 && ProjectUserStatus.COMPLETED !== this.projectUser.status.id) {
            getProjectRating(this.projectUser.id).then(projectRating => {
              if (projectRating.userRatings.length !== 0) {
                pushToProjectRating(this.projectUser.id, this.$router)
              }
            });
          }
        },
        async loadProjectWarnings() {
          if (this.projectUser.id === undefined) {
            this.showToast("Project user id is undefined for overview");
          }
          const { data } = await getProjectWarnings(this.projectUser.id);
          if (data) {
            this.projectWarnings = data;
          }
        },
        async confirmTasks() {
          this.$refs.confirmTasksButton.classList.add('p-disabled');

          var pTasks = [];

          let allPhasesHaveSomeTasks = this.createTasks
            .filter(apt => this.project.phases.some(p => p.id === apt.phase_id))
            .every(apt => !apt.assignments.some(task => task.enabled));
          if (allPhasesHaveSomeTasks) {
            this.showToast('Vähemalt 1 ülesanne igast etapist peab olema valitud', 'error');
            return;
          }

          this.createTasks.forEach((apt) => {
            pTasks.push({"phaseId": apt.phase_id, "tasks": apt.assignments});
          });

          await confirmAll(this.projectUser.id, {
            id: this.project.id,
            phaseTasks: pTasks
          }).then(async ({data}) => {
            this.processAxiosPositiveResponse(data);
            this.$refs.confirmTasksButton.classList.remove('p-disabled');
            await this.loadProjectDetail();
          }, (error) => {
            const toast = error.response?.data;
            if (toast) {
              this.processAxiosPositiveResponse(toast);
            } else {
              this.showToast('Ülesannete kinnitamine ebaõnnestus', 'error');
            }
            this.$refs.confirmTasksButton.classList.remove('p-disabled');
          });

        },
        async changeTasks() {
          this.$refs.changeTasksButton.classList.add('p-disabled');

          var pTasks = [];
          this.createTasks.forEach((apt) => {
            pTasks.push({"phaseId": apt.phase_id, "tasks": apt.assignments});
          });

          await changeAll(this.projectUser.id, {
            projectId: this.project.id,
            tasks: pTasks
          }).then(({ data }) => {
            this.$refs.changeTasksButton.classList.remove('p-disabled');
            this.processAxiosPositiveResponse(data);
          }, () => {
            this.$refs.changeTasksButton.classList.remove('p-disabled');
          });
          await this.loadProjectDetail();
        },
        async submitTasks() {
            this.$refs.submitTasksButton.classList.add('p-disabled');

            await updateAll(this.projectUser.id, {
              projectId: this.project.id,
              tasks: this.tasks.flatMap(t => t.assignments)
            }).then(({ data }) => {
                this.$refs.submitTasksButton.classList.remove('p-disabled');
                this.processAxiosPositiveResponse(data);
            }, () => {
              this.$refs.submitTasksButton.classList.remove('p-disabled');
            })

            await this.loadProjectDetail();
        },
        async submitDueDates() {
          this.$refs.submitDueDatesButton.classList.add('p-disabled');

          this.project.all_project_phases.forEach((phase) => {

            if (phase.due_at != null) {
              if (!(phase.due_at instanceof Date)) {
                phase.due_at = moment(phase.due_at, "DD/MM/YYYYY").toDate();
              }
              phase.due_at = new Date(phase.due_at.getTime() - phase.due_at.getTimezoneOffset() * 60000);
            }
          })

          await updateDueDates(this.projectUser.id, {
            areaPhases: this.project.all_project_phases
          }).then(({ data }) => {
            this.$refs.submitDueDatesButton.classList.remove('p-disabled');
            this.processAxiosPositiveResponse(data);
          }, () => {
            this.$refs.submitDueDatesButton.classList.remove('p-disabled');
          })
          await this.loadProjectDetail();
        },
        changeActiveTab(e) {
          this.activeTab = e.index;
          this.activeTabKey = this.$refs.doneTasksTabView.$children[e.index].$vnode.key;
        },
        changeActiveTabChooseTasks(e) {
          this.active = e.index;
          this.activeKey = this.$refs.chooseTasksTabView.$children[e.index].$vnode.key;
        },
        changeActiveTabChosenTasks(e) {
          this.active = e.index;
          this.activeKey = this.$refs.chosenTasksTabView.$children[e.index].$vnode.key;
          this.pickTasksDetailOpen = false;
        },
        showExpander(data) {
            return data?.items && data?.items?.length ? '' : 'no-expander';
        },
        initPriceChange(task) {
          task.price = null;
        },
        endPriceChange(task) {
          if (task.price === null) {
            task.price = task.estimatedPrice;
          }
          this.resetTaskTotals();
        },
        initTotalPriceChange(phaseId) {
          this.pickTasksActualPriceTotal.find(a => a.phase_id === phaseId).actualPrice = null;
        },
        endTotalPriceChange(phaseId) {
          let tasksPriceTotal = this.pickTasksActualPriceTotal.find(a => a.phase_id === phaseId);
          if (tasksPriceTotal.actualPrice === null) {
            tasksPriceTotal.actualPrice = this.totalActualPrice(this.tasks.find(a => a.phase_id === phaseId)?.assignments);
          } else {
            let newTotalPrice = tasksPriceTotal.actualPrice;
            let multiplier = newTotalPrice / tasksPriceTotal.estimatedPrice;

            this.tasks.find(a => a.phase_id === phaseId)?.assignments.forEach((task) => {
              task.price = Number((task.estimatedPrice * multiplier).toFixed(0));
            });

            let newTotal = tasksPriceTotal.actualPrice = this.totalActualPrice(this.tasks.find(a => a.phase_id === phaseId)?.assignments);

            let difference = Number(newTotalPrice - newTotal);

            if (difference !== 0) {
              let firstAssignment = this.tasks.find(a => a.phase_id === phaseId)?.assignments[0];
              firstAssignment.price += difference;
              tasksPriceTotal.actualPrice = this.totalActualPrice(this.tasks.find(a => a.phase_id === phaseId)?.assignments);
            }
          }
        },
        togglePickTasksDetail() {
          this.pickTasksDetailOpen = !this.pickTasksDetailOpen;
        },
        async saveNewTask() {
            var selectedPhase = null;

            if (this.activeKey === null) {
              selectedPhase = this.project.phases[0];
            } else {
              this.project.phases.some((obj) => {
                if(obj.id === this.activeKey)
                  selectedPhase = obj;
              });
            }

            if ((this.newTaskType && this.newTaskPrice) !== null) {
                if (this.project.phases.find(apa => apa.id === selectedPhase.id) === undefined) {
                  this.showToast('Valitud etapp ei ole projektis aktiivne ja sinna ülesannet lisada ei saa', 'error');
                  return;
                }

                this.createTasks.find(apa => apa.phase_id === selectedPhase.id)?.assignments.push({
                  enabled: true,
                  area_phase_id: this.newTaskType.area_phase_id,
                  title: this.newTaskType.title,
                  date: selectedPhase.due_at,
                  price: this.newTaskPrice,
                  comment: this.newTaskComment,
                  recipeId: this.newTaskType.id,
                  forLead: this.newTaskType.forLead,
                })

                this.clearNewTask();

                this.$toast.add({
                  severity: 'success',
                  summary: 'Salvestatud',
                  life: 3000,
                  closable: false
                })

            }
        },
        clearNewTask() {
            this.newTaskExpanded = false
            this.newTaskPrice = null
            this.newTaskComment = null
            this.newTaskType = null
        },
        downloadContract() {
          this.downloadFile('/project/' + this.projectUser.id + '/contract', 'Leping_' + this.project.number + '.pdf');
        },
        downloadFile(path, fileName) {
            getFile(path)
            .then((res) => {
                var fileURL = window.URL.createObjectURL(new Blob([res.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', fileName);
                document.body.appendChild(fileLink);

                fileLink.click();
            }, (error) => {
               error.response.data.text().then(text => {
                 const toast = JSON.parse(text);
                 this.processAxiosPositiveResponse(toast);
               });
            });
        },
        async contractAcceptance() {
          this.$refs.contractAcceptanceButton.classList.add('p-disabled');
          acceptContract(this.projectUser.id).then(({ data }) => {
              this.$refs.contractAcceptanceButton.classList.remove('p-disabled');
              this.processAxiosPositiveResponse(data);
              this.project.isContractAccepted = true;
          }, () => {
            this.$refs.contractAcceptanceButton.classList.remove('p-disabled');
          })
        },
        async loadProjectDetail() {
          await this.loadProjectUser();
          await this.loadProject();
          if (ProjectUserRole.isTeamLead(this.projectUser.role.id)) {
            await this.loadProjectWarnings();
          }
        },
        totalEstimatedPrice: function (tasks) {
          if (tasks === undefined) {
            return 0;
          } else {
            return Object.values(tasks)
            .filter(task => task.enabled)
            .map(task => task.estimatedPrice)
            .reduce((a,b)=>{
              return b ? a + b : a;
            }, 0);
          }
        },
        totalActualPrice: function (tasks) {
          if (tasks === undefined) {
            return 0;
          } else {
            return Object.values(tasks)
            .filter(task => task.enabled)
            .map(task => task.price)
            .reduce((a,b)=>{
              return b ? a + b : a;
            }, 0);
          }
        },
        async loadProjectUser () {
          getProjectUser(this.$route.params.projectUserId).then((resp) => {
            this.projectUser = resp.data;
          });
        },
        showProfile(memberId) {
          this.memberId = memberId;
          this.showModal = true;
          window.scrollTo(0, 0);
        },
        areaRowClass(data) {
          return data.enabled ? null : 'bg-gray-200';
        },
        async toggleProjectAreaPhase(areaId, phaseId) {
          toggleAreaPhase(this.projectUser.id, areaId, phaseId).then(() => {
            this.showToast('Etapid uuendatud');
            this.loadProjectDetail();
            // Todo: refresh only data
            this.$router.go(0);
          })
        },
        async toggleProjectArea(areaId) {
          toggleArea(this.projectUser.id, areaId).then(() => {
            this.showToast('Valdkonnad uuendatud');
            this.loadProjectDetail();
            // Todo: refresh only data
            this.$router.go(0);
          })
        },
        isTeamLeadInWaitingProjectStatus() {
          return ProjectUserRole.isTeamLead(this.projectUser.role.id) && ProjectStatus.isInviteSpecialistStatuses(this.project.status.id);
        },
        resetTaskTotals() {
          this.pickTasksActualPriceTotal = [];
          this.project.phases.forEach(p => {
            let assignments = this.tasks.find(a => a.phase_id === p.id)?.assignments;
            this.pickTasksActualPriceTotal.push(
                {
                  phase_id: p.id,
                  estimatedPrice: this.totalEstimatedPrice(assignments),
                  actualPrice: this.totalActualPrice(assignments)
                });
          });
        },
    },
    async mounted() {
        await this.loadProjectDetail();
    },
    filters: {
      truncate: function (text, length, suffix) {
        if (text === null) {
          return null;
        }
        if (text.length > length) {
          return text.substring(0, length) + suffix;
        } else {
          return text;
        }
      }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .no-expander .p-row-toggler {
        opacity: 0;
        pointer-events: none;
    }

    tr.no-expander > td {
        border: 0;
    }

    .p-datatable--alt {
        table {
            border-collapse: separate;
            border-spacing: 0 0.5rem;
        }

        .p-datatable-thead {
            th {
                @apply py-1;

                border: none;
            }
        }

        .p-datatable-tbody {
            tr {
                @apply bg-white;
            }

            td {
                @apply px-6;

                &:first-child, &:last-child {
                    @apply px-6;
                }

                border: none;
            }

            .p-row-toggler {
                @apply w-8 h-8 rounded-full bg-blue-500;

                &:enabled:hover {
                    @apply bg-blue-500;
                }

                .p-row-toggler-icon::before {
                    content: "\e942";
                    color: #fff;
                }
            }
        }
    }
}
</style>

<style>
div[id*="tooltip"] {
  max-width: 40%;
}
.warning-accordion .p-accordion-content {
  background: none !important;
}
</style>
